export default "__VITE_ASSET__TzJCKzvB__"